// This file is used to initialize the AP Shared Library using an instance of ap-exerciser-sdk. 
import { ExerciserSDK } from "ap-exerciser-sdk";

export const initializeApSharedLib = (sessionLanguage: any, sdk: ExerciserSDK) => {
    const observerInstance = sdk.getObserverAppInstance();
    observerInstance.attach("OBSERVER:APP:ATTACHED", (attachedapp: any) => {
        if (attachedapp === "appa") {
            observerInstance.trigger("language:change", sessionLanguage === "en" ? "en" : "fr");
            observerInstance.trigger("language:load", sessionLanguage === "en" ? "en" : "fr");
            observerInstance.trigger("geoblocking:check");
            observerInstance.trigger("initLocalizedRoutes", sessionLanguage === "en" ? "en" : "fr");
        }
    });
}

